// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__Zacaw","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__2qBZt","gfeWrapper":"CalendarEvent_gfeWrapper__3NWxd"};